import { Transition } from '@headlessui/react';
import { memo, useCallback } from 'react';
import { IconPalette, IconTrash } from '@tabler/icons-react';
import CaptionTypographyPopover from './popovers/CaptionTypographyPopover';
import CaptionOutlinePopover from './popovers/CaptionOutlinePopover';
import CaptionShadowPopover from './popovers/CaptionShadowPopover';
import CaptionHighlightPopover from './popovers/CaptionHighlightPopover';
import CaptionBackgroundPopover from './popovers/CaptionBackgroundPopover';
import CaptionAnimationPopover from './popovers/CaptionAnimationPopover';
import PlayerMenuTooltip from '../../PlayerMenus/PlayerMenuTooltip';
import { SelectionOutlineAction } from '../../Outlines/types';
import { classnames } from '@/libs/utils';
import EventBus from '@/libs/eventBus/eventBus';
import { toggleCaptions } from '@/stores/clip';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { CustomEvents } from '@/libs/eventBus/constants';

function CaptionsMenuV2() {
  const { clipId } = useClipsContext();

  const removeCaptions = useCallback(() => {
    toggleCaptions(clipId, false);
    EventBus.dispatch(CustomEvents.SelectionOutlineAction, {
      action: SelectionOutlineAction.DESELECT
    });
  }, [clipId]);

  const openCaptionsGallery = useCallback(() => {
    EventBus.dispatch(CustomEvents.OpenCaptionsGallery);
  }, []);

  return (
    <Transition
      appear
      as="div"
      show
      className="relative z-[60] flex cursor-auto select-none items-center justify-center transition-all duration-100"
      enterFrom="opacity-0 max-h-0"
      enterTo="opacity-100 max-h-96"
      leaveFrom="opacity-100 max-h-96"
      leaveTo="opacity-0 max-h-0"
    >
      <div
        id="captions-menu"
        onPointerDown={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
        className={classnames('relative flex flex-col rounded-lg border bg-white shadow')}
      >
        <div className="flex border-b border-slate-200 p-1">
          <CaptionTypographyPopover />
          <CaptionOutlinePopover />
          <CaptionShadowPopover />
          <CaptionHighlightPopover />
          <CaptionBackgroundPopover />
          <CaptionAnimationPopover />
          <button
            data-testid="captions-menu-preset-button"
            className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
            onClick={openCaptionsGallery}
          >
            <div className="flex w-10 cursor-pointer items-center justify-center rounded-md">
              <IconPalette size={16} />
              <PlayerMenuTooltip content="Caption Style Presets" />
            </div>
          </button>
          <button
            data-testid="captions-menu-remove-button"
            className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
            onClick={removeCaptions}
          >
            <div className="flex w-10 cursor-pointer items-center justify-center rounded-md">
              <IconTrash size={16} />
              <PlayerMenuTooltip content="Remove Captions" />
            </div>
          </button>
        </div>
      </div>
    </Transition>
  );
}

export default memo(CaptionsMenuV2);
